<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content with-tab-footer">
        <el-form
          class="box"
          ref="productForm"
          :model="product"
          label-width="70px"
        >
          <fieldset class="mgb15">
            <legend>{{ $t("text.baseInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('product.productNo')">{{
                  product.productNo
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('product.name')">{{
                  product.name
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('product.category')">{{
                  product.categoryName
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('product.unit')">{{
                  product.unit
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('text.price')" :prop="'rentPrice'">
                  {{ product.rentPrice }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('text.createAt')" :prop="'createAt'">
                  {{ product.createdAt }}
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset v-if="product.images != null" class="mgb15">
            <legend>{{ $t("product.images") }}</legend>
            <thumbnail
              :images="product.images"
              :list="true"
              width="50"
              height="auto"
            />
          </fieldset>
          <fieldset v-if="product.introduction != null" class="mgb15">
            <legend>{{ $t("product.introduction") }}</legend>
            <raw-html :content="product.introduction" />
          </fieldset>
        </el-form>
      </div>
    </div>
    <div class="drawer-footer">
      <el-button
        v-if="activeName == 'detail' && Permit.canActions('serviceManage')"
        type="success"
        size="small"
        @click="copy"
        >{{ $t("action.copy") }}</el-button
      >
    </div>
    <!-- 产品复制 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.copy')"
      :close-on-click-modal="false"
      :visible.sync="copyDF"
      width="30%"
    >
      <el-form ref="copyObjForm" :model="copyObj" label-width="60px">
        <el-form-item
          :label="$t('product.productNo')"
          :prop="'productNo'"
          :rules="[
            {
              required: true,
              validator: validateProductNo,
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="copyObj.productNo" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="copySubmitDoing"
          size="small"
          @click="copySubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="copyDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page, table } from "@/utils/mixins.js";
import Thumbnail from "@/components/Thumbnail";
import RawHtml from "@/components/RawHtml";
import Product from "@/api/product.js";

export default {
  props: {
    id: null,
  },
  mixins: [page, table.pager, table.search, table.checker],
  components: {
    Thumbnail,
    RawHtml,
  },
  data() {
    var validateProductNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("product.productNo")]))
        );
        return;
      }
      Product.findByProductNo({ productNo: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("product.productNo")]))
          );
        } else {
          callback();
        }
      });
    };
    return {
      activeName: "detail",
      product: { uuid: null },
      asyncImageToInvDoing: false,

      // 复制
      validateProductNo: validateProductNo,
      copyDF: false,
      copyObj: {
        productNo: null,
      },
      copySubmitDoing: false,
    };
  },
  created() {
    const self = this;
    self.getProduct();
  },
  methods: {
    getProduct() {
      const self = this;
      self.loadingStart();
      Product.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.product = res.data.entity;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    //产品复制
    copy() {
      const self = this;
      self.copyObj.productNo = self.product.productNo + "Copy";
      self.copySubmitDoing = false;
      self.copyDF = true;
    },
    copySubmit() {
      const self = this;
      this.$refs.copyObjForm.validate((valid) => {
        if (valid) {
          self.copySubmitDoing = true;
          Product.copy(self.product.id, self.copyObj).then(function (res) {
            self.copySubmitDoing = false;
            self.copyDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.copySuccess"),
                type: "success",
              });
              self.$emit("updateInfo");
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // //
    // asyncImageToInv() {
    //   const self = this;
    //   self.asyncImageToInvDoing = true;
    //   Product.asyncImageToInv(self.product.id).then(function (res) {
    //     self.asyncImageToInvDoing = false;
    //     if (res.status === 200) {
    //       self.$message({
    //         message: self.$t("prompt.asyncSuccess"),
    //         type: "success",
    //       });
    //     } else {
    //       self.sysError();
    //     }
    //   });
    // },
  },
};
</script>